
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import ImportPartsInbound from "../components/import-parts-inbound.vue";
import t from "@common/src/i18n/t";
const base = namespace("base");
const staff = namespace("staff");
const management = namespace("management");
const app = namespace("app");
const common_inventory = namespace("common_inventory");
const parts = namespace("parts");

@InjectFunction("dayjs", "emptyToLine", "splitThousands", "permit", "permitApp", "appCode")
@Component({
  components: { ImportPartsInbound }
})
@Table("loadListData")
export default class InWarehouse extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @management.Action getStoreList;
  @common_inventory.Action queryTransferWarehouseList;
  @common_inventory.Action comfirmTransferWarehouse;
  @parts.Action getPartsList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  orderList: any[] = [];
  orderStatusList: any[] = [];
  staffList: any[] = [];
  created() {
    this.init();
    this.loadListData();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("transfer_warehouse_status").then(data => {
      this.orderStatusList = data;
    });
    this.searchParts("");
    // 员工和顾问 List
    this.getStaffList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      const staffList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.staffName,
        value: item.userCode
      }));
      this.staffList = staffList;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryTransferWarehouseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleConfirmTransfer() {
    this.btnStartLoading();
    this.comfirmTransferWarehouse({
      transferCode: this.activeRow.transferCode
    })
      .then(() => {
        this.$message.success(t("v210.stock-transfer-doc-moved"));
        this.loadListData();
        this.showInConfirmTips = false;
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  searchForm = {
    transferCode: "",
    transferStaffUserCode: "",
    transferTimeStart: "",
    transferTimeEnd: "",
    createTimeStart: "",
    createTimeEnd: "",
    status: "",
    partsCode: ""
  };
  get searchList() {
    return [
      {
        label: t("v210.stock-transfer-no"),
        type: "input",
        value: "",
        prop: "transferCode"
      },
      {
        label: t("v210.moved-by"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "transferStaffUserCode"
      },
      {
        label: t("v210.transfer-time"),
        type: "daterange",
        value: "",
        prop: "transferTime",
        valueDistribute: ["transferTimeStart", "transferTimeEnd"]
      },
      {
        label: t("v213.Created-time"),
        type: "daterange",
        value: "",
        prop: "createTime",
        valueDistribute: ["createTimeStart", "createTimeEnd"]
      },
      {
        label: t("v213.Transfer-status"),
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "status"
      },
      {
        label: t("parts.text"),
        type: "select-search",
        value: "",
        prop: "partsCode",
        placeholder: t("v210901.enter-spare-parts-search"),
        selectList: this.partsList,
        searchFun: this.searchParts
      }
    ];
  }
  partsList: any = [];
  searchParts(partsName) {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        return {
          label: item.partsName,
          value: item.partsCode
        };
      });
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "startInboundDate") {
          this.searchForm["startInboundDate"] = item.value ? item.value[0] : "";
          this.searchForm["endInboundDate"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleEdit(row) {
    this.$router.push(`/inventory/transfer-warehouse-edit/${row.transferCode}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}?tenantCode=${row.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/inventory/transfer-warehouse-view/${row.transferCode}`
    });
    window.open(href, "_blank");
  }
  storeList: any = [];
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  // 2.10
  activeRow: any = {};
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips(row) {
    this.showInConfirmTips = true;
    this.activeRow = row;
  }
}
